
import { Box } from "@mui/material";
import { FormattedDate } from "utils/DateUtils";

interface ShipMarkerProps {
	actual: boolean;
	course?: number | null;
	label?: string;
	lastLocationUpdate?: number | null;
	color?: string;
	onClick?: () => void;
}

const ShipMarker = ({
	actual,
	course,
	label,
	lastLocationUpdate,
	color,
	onClick,
}: ShipMarkerProps) => {
	return (
		<Box
			onClick={() => onClick?.()}
			sx={{
				cursor: onClick ? "pointer" : "auto",
				height: 32,
				left: -16,
				position: "relative",
				top: -16,
				width: 32,

				"--label-display": "inherit",
			}}>

			<Box
				sx={{
					backgroundColor: color || "#333",
					borderRadius: "50% 50% 2px 2px",
					height: 32,
					left: 7,
					position: "relative",
					transform: `rotate(${course ?? 0}deg)`,
					width: 18,
				}}>

				<Box
					sx={{
						backgroundColor: actual ? "#46DA4C" : "#9B9B9B",
						border: "1px solid #FFF",
						borderRadius: "30px",
						height: 10,
						left: 4,
						position: "absolute",
						top: 13,
						width: 10,
					}} />
			</Box>

			{label && (
				<Box
					sx={{
						backgroundColor: "#fff",
						borderRadius: "4px",
						boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
						color: "#000",
						display: "var(--label-display)",
						left: 40,
						maxWidth: 170,
						overflow: "hidden",
						pl: 1,
						pr: 1,
						py: "3px",
						position: "absolute",
						top: "50%",
						transform: "translateY(-50%)",
						zIndex: 50,
					}}>
					<Box sx={{ fontSize: 13, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
						{label}
					</Box>
					{lastLocationUpdate != null && (
						<Box sx={{ color: "#666", fontSize: 11, fontWeight: 400, whiteSpace: "nowrap", mt: "2px" }}>
							<FormattedDate date={lastLocationUpdate} format="D MMM, YYYY HH:mm" />
						</Box>
					)}
				</Box>
			)}
		</Box>
	);
};

export default ShipMarker;
